import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withKeys as _withKeys, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f4e2740"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Posições do Plantão", -1))
const _hoisted_2 = { class: "flex flex-col gap-2" }
const _hoisted_3 = {
  key: 0,
  class: "flex justify-center"
}
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "w-full table-fixed" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("colgroup", null, [
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"70%"} }),
  /*#__PURE__*/_createElementVNode("col", { style: {"width":"30%"} })
], -1))
const _hoisted_7 = { class: "pr-1" }
const _hoisted_8 = ["onKeyup"]
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "pr-4 text-left" }
const _hoisted_11 = {
  key: 0,
  class: "absolute inset-0 flex justify-center items-center bg-white bg-opacity-50 z-50"
}
const _hoisted_12 = {
  key: 0,
  class: "text-gray-500 text-center mt-4"
}
const _hoisted_13 = {
  key: 2,
  class: "text-red-500"
}
const _hoisted_14 = { class: "flex justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_save_disk_icon = _resolveComponent("save-disk-icon")!
  const _component_edit_icon = _resolveComponent("edit-icon")!
  const _component_outline_button = _resolveComponent("outline-button")!
  const _component_modal_vue = _resolveComponent("modal-vue")!
  const _directive_focus = _resolveDirective("focus")!

  return (_openBlock(), _createBlock(_component_modal_vue, {
    onClose: $setup.handleToggleModal,
    modalActive: $setup.modals[$setup.modalName]
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_outline_button, {
          width: "119px",
          onClick: $setup.handleToggleModal,
          text: "Fechar"
        }, null, 8, ["onClick"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        ($setup.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_v_progress_circular, {
                indeterminate: "",
                color: "primary"
              })
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("table", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.positions, (position) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: position.id,
                      class: "fixed-row border-b"
                    }, [
                      _createElementVNode("td", _hoisted_7, [
                        ($setup.editingPositionId === position.id)
                          ? _withDirectives((_openBlock(), _createElementBlock("input", {
                              key: 0,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.editName) = $event)),
                              onKeyup: _withKeys(($event: any) => ($setup.saveUpdate(position)), ["enter"]),
                              class: "border rounded px-2 py-1 text-center"
                            }, null, 40, _hoisted_8)), [
                              [_vModelText, $setup.editName],
                              [_directive_focus]
                            ])
                          : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(position.name), 1))
                      ]),
                      _createElementVNode("td", _hoisted_10, [
                        ($setup.editingPositionId === position.id)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              ($setup.savingPositionId === position.id)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                    _createVNode(_component_v_progress_circular, {
                                      indeterminate: "",
                                      color: "primary"
                                    })
                                  ]))
                                : (_openBlock(), _createBlock(_component_save_disk_icon, {
                                    key: 1,
                                    onClick: _withModifiers(($event: any) => ($setup.saveUpdate(position)), ["stop"]),
                                    class: "cursor-pointer",
                                    width: "24",
                                    height: "24",
                                    style: _normalizeStyle({ pointerEvents: $setup.isLoading ? 'none' : 'auto' }),
                                    "aria-label": "Salvar nome da posição",
                                    title: "Salvar"
                                  }, null, 8, ["onClick", "style"]))
                            ], 64))
                          : (_openBlock(), _createBlock(_component_edit_icon, {
                              key: 1,
                              onClick: _withModifiers(($event: any) => ($setup.handleUpdate(position)), ["stop"]),
                              class: "cursor-pointer text-blue-500 hover:text-blue-700"
                            }, null, 8, ["onClick"]))
                      ])
                    ]))
                  }), 128))
                ])
              ]),
              ($setup.positions.length === 0)
                ? (_openBlock(), _createElementBlock("p", _hoisted_12, " Nenhuma posição disponível para este plantão. "))
                : _createCommentVNode("", true)
            ])),
        ($setup.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString($setup.error), 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["onClose", "modalActive"]))
}